export default class PricingPlan {
  /**
   * Create new pricing plan and set properties based on the given object.
   *
   * @param {Object} obj
   */
  constructor (obj) {
    Object.assign(this, obj)
  }
}
